import { Injectable } from '@angular/core';
import { GoDialogRef } from '@go-modules/services/go-dialog-ref/go-dialog-ref';
import { GoModalService } from '@go-modules/services/go-modal/go-modal.service';
import type { ActivityPreviewEditorDialogData } from './activity-preview-editor-dialog.shared';

export * from './activity-preview-editor-dialog.shared';

@Injectable({
	providedIn: 'root'
})
export class ActivityPreviewEditorDialogService {
	constructor (private goModal: GoModalService) {}

	public async open (data: ActivityPreviewEditorDialogData): Promise<GoDialogRef> {
		const { ActivityPreviewEditorDialogComponent } = await import('./activity-preview-editor-dialog.component');

		return this.goModal.open(ActivityPreviewEditorDialogComponent, false, {
			data,
			closeOnEscape: false,
			focusReturnSelector: data.focusReturnSelector
		});
	}
}
